<section class="promotion-winners">
  <go-back class="promotion-winners__mobile-back"></go-back>

  <workspace-breadcrumb class="promotion-winners__breadcrumb"></workspace-breadcrumb>

  <header class="promotion-winners__header">
    <h1>{{ 'promotions.allWinners' | translate }}</h1>
    <p>{{ 'promotions.latestWinners' | translate }}</p>
  </header>

  @if (isLoading()) {
    <div class="promotion-winners__loader">
      <korviu-loader></korviu-loader>
    </div>
  } @else if (loadError()) {
    <div class="promotion-winners__empty" role="alert">
      <div>
        <p>{{ 'promotions.winnersLoadError' | translate }}</p>
        <button type="button" (click)="loadWinners(currentPage())">{{ 'promotions.retry' | translate }}</button>
      </div>
    </div>
  } @else if (rankedWinners().length) {
    <div class="promotion-winners__list">
      @for (winner of rankedWinners(); track winner.viewId) {
        <article class="promotion-winners__list-item">
          <span class="promotion-winners__rank">#{{ winner.position }}</span>

          <div class="promotion-winners__list-avatar">
            @if (winner.avatarUrl) {
              <img [src]="winner.avatarUrl" [alt]="winner.name" />
            } @else {
              <span aria-hidden="true">{{ winner.participant.first_name.charAt(0) }}</span>
            }
          </div>

          <div class="promotion-winners__list-info">
            <h2>{{ winner.name }}</h2>
            <p>{{ winner.campaign_name }} · {{ winner.claimed_at | date: 'mediumDate' }}</p>
          </div>

          <strong class="promotion-winners__list-amount">
            @if (winner.reward.value) {
              {{ winner.reward.value }}
            }
            {{ 'promotions.campaignDetails.rewardTypes.' + winner.reward.reward_type | translate }}
          </strong>
        </article>
      }
    </div>

    @if (totalPages() > 1) {
      <nav class="promotion-winners__pagination" [attr.aria-label]="'promotions.winnersPages' | translate">
        <nz-pagination
          [nzPageIndex]="currentPage()"
          [nzPageSize]="pageSize"
          [nzTotal]="totalWinners()"
          [nzHideOnSinglePage]="true"
          nzSize="small"
          (nzPageIndexChange)="loadWinners($event)"
        />
      </nav>
    }
  } @else {
    <div class="promotion-winners__empty">
      <korviu-no-data size="large" [message]="'promotions.noPromotionWinners' | translate"></korviu-no-data>
    </div>
  }
</section>
